export const CREDIBILITY_LEAD =
  "We're currently interviewing the first 100 AI-using junior developers to shape Prepzio.";

export const CREDIBILITY_SUB =
  'Built from early conversations with self-taught and bootcamp juniors who use ChatGPT, Copilot, or Cursor while learning. No inflated user counts on this page, just problems we keep hearing in those calls.';
